import React, { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import MVPPanel from 'datapanelInAcore/pages/mvp-panel';
import NewGuide from '../components/new-guide';
import SalesPlanDrawer from '@/pages/product-manager/sale-plan/components/sales-plan-drawer';
import { ModalOfDownloadPlan } from '@/pages/product-manager/sale-plan';

// 详情:  editable: true
// {code: xxx, editable?: boolean} 没有editable详情，没有code是列表
// { create: true} 创建

export default function Panel() {
  const history = useHistory();
  const [showEditDrawer, setShowEditDrawer] = useState(false);

  const modalRef = useRef(null);
  const drawerRef = useRef(null);
  const downloadModalInstance = useRef(null);
  const mvpRef = useRef(null);

  function onOkDownload() {
    message.success('下载成功，文件稍后通过鲸盘进行推送', 5);
  }

  const openDrawer = {
    new: () => {
      setShowEditDrawer(true);
      drawerRef.current.getOpenStatus({ status: 'new' });
    },
    edit: (id) => {
      setShowEditDrawer(true);
      drawerRef.current.getOpenStatus({ status: 'edit', id: id });
    },
    view: (id) => {
      setShowEditDrawer(true);
      drawerRef.current.getOpenStatus({ status: 'view', id: id });
    },
  };

  return (
    <>
      <MVPPanel
        ref={mvpRef}
        showNewerGuide={() => {
          modalRef.current.show();
        }}
        toSalePlan={({ create, code, editable } = {}) => {
          if (create) return history.push('/product-manager/sale-plan?create=1');
          // if (editable && code) return history.push('/product-manager/sale-plan?editable=1&code=' + code);
          // if (code) return history.push('/product-manager/sale-plan?code=' + code);
          if (editable && code) {
            openDrawer.edit(code);
            return;
          }
          if (code) {
            openDrawer.view(code);
            return;
          }
          history.push('/product-manager/sale-plan');
        }}
        toProductGroup={({ create, code, editable } = {}) => {
          if (create) return history.push('/product-manager/product-group?create=1');
          if (editable) return history.push('/product-manager/product-group?editable=1&code=' + code);
          if (code) return history.push('/product-manager/product-group?code=' + code);
          history.push('/product-manager/product-group');
        }}
      />
      <NewGuide ref={modalRef} />
      <SalesPlanDrawer
        ref={drawerRef}
        onClose={() => {
          setShowEditDrawer(false);
          mvpRef?.current?.reLoad();
        }}
        visible={showEditDrawer}
        onDownLoad={(id) => downloadModalInstance.current.show(id)}
      />
      <ModalOfDownloadPlan ref={downloadModalInstance} onOkDownload={onOkDownload} />
    </>
  );
}
